export default __webpack_public_path__ + "static/media/DNA_PAINT_Jungmann.a9108807.png";